<template>
  <div class="wrapper">
    <parallax
      :style="headerStyle"
      class="section page-header header-filter"
    ></parallax>
    <div class="main main-raised-top">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <h4 class="title"></h4>
              </div>

              <img :src="img" class="rounded" />
            </div>

            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <h4 class="title"></h4>
              </div>
              <h4 class="title text-left">
                常州华龙通信科技股份有限公司，成立于1998年，是一家高新技术、软件、质量管理体系认证、环境管理体系认证的科技型企业，并2016年正式在新三板挂牌上市。
              </h4>
              <h5 class="text-left">
                华龙科技拥有全部自主知识产权的光通信传输产品和空中信息采集产品，如光端机，光纤收发器、工业级交换机、多业务光交换系统、WIFI探针、4G探针、ETC路测单元等系列产品。
              </h5>
              <h5 class="text-left">
                近年来，公司围绕科技赋能、物联应用、综合治理和安全管理等核心领域，运用大数据、云计算和人工智能等技术，向客户提供方案设计、产品定制、软件研发、系统集成及运营维护的一站式综合解决方案，是一家专业的智慧政法、智慧社区、智慧城市的IT服务商。
              </h5>
              <div class="profile">
                <h4 class="title"></h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";

export default {
  bodyClass: "profile-page",

  props: {
    header: {
      type: String,
      default: require("@/assets/img/about.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/history.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}
</style>
